export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/sidebar-logo.png?69c8ab64fd1cfda09f22fc646c162ca4";